import { memo } from 'react';

import DragHandleIconSVG from '@/assets/drag-handle-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDragHandleIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={DragHandleIconSVG} {...props} />
);

export const DragHandleIcon = memo(IDragHandleIcon) as typeof IDragHandleIcon;
